import get from 'lodash/get'
import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'encuestas/respuestas'
  }),
  getters: {},
  mutations: {},
  actions: {
    async save ({ commit, state }, params) {
      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.post(`${state.endpoint}/add`, params)
        const data = get(response, 'data.data', {})
        commit('setLoading', -1, { root: true })

        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    }
  }
}
